<template>
	<div>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">{{ $t('chatMessageOrderDetails.supplier') }}</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p class="supplier-name">
						<span>{{ data.supplier_name }}</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row v-if="data.isGroupOrder">
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">{{ $t('chatMessageOrderDetails.orderBy') }}</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ data.order_by.phone_number }}</span> &nbsp;
						<span>({{ data.order_by.nick_name }})</span>
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">Bill to</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ data.bill_customer.customer_id }}</span> &nbsp;
						<span>{{ data.bill_customer.customer_name }}</span>
					</p>
					<p>
						{{ data.bill_customer.address }}
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">Ship to</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>
						<span>{{ data.ship_customer.customer_id }}</span> &nbsp;
						<span>{{ data.ship_customer.customer_name }}</span>
					</p>
					<p>
						{{ data.ship_customer.address }}
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">{{ $t('chatMessageOrderDetails.deliveryDate') }}</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<el-tag v-if="data.isNotNextDay" type="danger">{{ data.delivery_date }}</el-tag>
					<p v-else>{{ data.delivery_date }}</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">{{ $t('chatMessageOrderDetails.comment') }}</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>{{ data.comment ? data.comment : "No Comment" }}</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">{{ $t('chatMessageOrderDetails.ordered') }}</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>{{ data.items_count ? data.items_count + " ITEMS" : "" }}</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">{{ $t('chatMessageOrderDetails.include') }}</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light">
					<p>{{ data.items_include }}</p>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<div class="grid-content bg-purple"><span class="span-weight">{{ $t('chatMessageOrderDetails.orderDetails') }}</span></div>
			</el-col>
			<el-col :span="18">
				<div class="grid-content bg-purple-light" style="margin: 0" v-for="(item, index) in data.items" :key="index">
					<el-row>
						<el-col :span="18">
							<div class="grid-content bg-purple">
								<span class="span-weight"> {{ item.product.name }}</span>
								<div
									v-for="(element, index) in item.attributes"
									:key="index"
									v-if="(element.option_name !== 'PC') & (element.option_name !== 'CASE')"
								>
									<span>({{ element.option_name }})</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="grid-content bg-purple-light">
								<span
									class="span-weight"
									v-for="(element, index) in item.attributes"
									:key="index"
									v-if="element.option_name === 'PC' || element.option_name === 'CASE'"
								>
									{{ item.qty }} {{ element.option_name }}
								</span>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name: "chat-message-order-details",

	props: {
		data: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="less" scoped>
.span-weight {
	font-weight: 700;
	font-size: 16px;
	color: black;
	margin-bottom: 20px;
}
.grid-content {
	margin-bottom: 20px;
}

.grid-content p {
	margin-top: 0px;
	margin-bottom: 10px;
}

.supplier-name {
	font-weight: 400;
	font-size: 15px;
	color: black;
}
</style>
